<template>
  <div class="callback-wrap" v-loading="loading" ref="main">
    <div class="scroll" ref="content">
      <div class="item-wrap">
        <div class="table-header">
          <div class="h2-title">关键行为配置</div>
        </div>
        <ul class="data-list" v-if="behaviorList.length > 0">
          <li class="data-item">
            <span class="header-text">参数名称:</span>
          </li>
          <li class="data-item" v-for="(behaviorItem, index) of behaviorList" :key="behaviorItem.callBackName">
            <el-select class="select-item" v-model="behaviorItem.callBackName" placeholder="请选择参数名称">
              <el-option
                v-for="item of behaviorOptionList"
                :key="item.value"
                :label="item.value"
                :value="item.value"
                :disabled="item.disabled"
              >
              </el-option>
            </el-select>
            <i class="del-icon el-icon-delete" @click="delConf(index, 'behavior')"></i>
          </li>
        </ul>
        <div class="nodata-tips" v-else>暂无配置</div>
        <el-button class="add-btn" icon="el-icon-plus" plain @click="addConf('behavior')">新增参数</el-button>
      </div>
      <div class="center-line"></div>
      <div class="item-wrap">
        <div class="table-header">
          <div class="h2-title">激活配置</div>
        </div>
        <ul class="data-list" v-if="activeList.length > 0">
          <li class="data-item">
            <span class="header-text">参数名称:</span>
          </li>
          <li class="data-item" v-for="(activeItem, index) of activeList" :key="activeItem.callBackName">
            <el-select class="select-item" v-model="activeItem.callBackName" placeholder="请选择参数名称">
              <el-option
                v-for="item of activeOptionList"
                :key="item.value"
                :label="item.value"
                :value="item.value"
                :disabled="item.disabled"
              >
              </el-option>
            </el-select>
            <i class="del-icon el-icon-delete" @click="delConf(index, 'active')"></i>
          </li>
        </ul>
        <div class="nodata-tips" v-else>暂无配置</div>
      </div>
      <el-button class="add-btn" icon="el-icon-plus" plain @click="addConf('active')"> 新增参数 </el-button>
    </div>
    <div class="footer">
      <div class="btn-wrap">
        <el-button class="btn-item" type="primary" @click="saveData">保 存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { callbackOptionConf } from "./selectConf.js";
import { queryCbPara, addCbPara } from "@/api/tools.js";
export default {
  name: "CallbackConf",
  props: ["params"],
  data() {
    return {
      loading: false,
      behaviorList: [],
      activeList: [],
      optionList: callbackOptionConf,
    };
  },
  methods: {
    searchData() {
      this.loading = true;
      queryCbPara({
        platType: this.params.curPlatType,
        pkg: this.params.pkg,
      }).then((res) => {
        this.loading = false;
        if (res.code === "0000") {
          this.behaviorList = res.callBackMap["25"] ? res.callBackMap["25"] : [];
          this.activeList = res.callBackMap["0"] ? res.callBackMap["0"] : [];
        }
      });
    },
    addConf(addType) {
      if (addType === "behavior") {
        this.behaviorList.push({
          platType: this.params.curPlatType,
          callBackName: null,
          callBackEvent: 25,
          pkg: this.params.pkg,
        });
      } else {
        this.activeList.push({
          platType: this.params.curPlatType,
          callBackName: null,
          callBackEvent: 0,
          pkg: this.params.pkg,
        });
      }
    },
    delConf(delIndex, type) {
      if (type === "behavior") {
        this.behaviorList.splice(delIndex, 1);
      } else {
        this.activeList.splice(delIndex, 1);
      }
    },
    saveData() {
      let allList = this.behaviorList.concat(this.activeList);
      let errorData = allList.find((item) => item.callBackName === null);
      if (errorData) {
        this.$message({
          message: "部分数据未填写完整",
          type: "warning",
        });
      } else {
        addCbPara({
          data: allList,
        }).then((res) => {
          if (res.code === "0000") {
            this.$message({
              message: "保存成功",
              type: "success",
            });
          }
        });
      }
    },
  },
  computed: {
    chnlName() {
      switch (this.params.curPlatType) {
        case 1:
          return "巨量引擎";
        case 2:
          return "腾讯广告";
        case 3:
          return "巨量星图";
        default:
          return "-";
      }
    },
    behaviorOptionList() {
      let copyList = JSON.parse(JSON.stringify(callbackOptionConf));
      let options = copyList.map((item) => {
        return {
          value: item,
          disabled: this.behaviorList.map((item) => item.callBackName).includes(item),
        };
      });
      return options;
    },
    activeOptionList() {
      let copyList = JSON.parse(JSON.stringify(callbackOptionConf));
      let options = copyList.map((item) => {
        return {
          value: item,
          disabled: this.activeList.map((item) => item.callBackName).includes(item),
        };
      });
      return options;
    },
  },
  watch: {
    params: {
      handler(val) {
        if (val.curPlatType && val.pkg) {
          this.searchData();
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="less" scoped>
.callback-wrap {
  padding: 0 0px 24px 24px;
  height: calc(100vh - 195px);
  overflow: hidden;
  box-sizing: border-box;
  .scroll {
    height: calc(100% - 40px);
    overflow: auto;
    .add-btn {
      width: 300px;
      height: 32px;
      color: rgba(24, 144, 255, 1);
      border-color: rgba(24, 144, 255, 1);
      margin-top: 6px;
    }
  }
  .item-wrap {
    .table-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 4px 24px 0px 4px;
      .h2-title {
        color: rgba(0, 0, 0, 0.85);
        font-weight: bold;
        font-size: 14px;
        padding: 0px 0 14px 0;
        &::before {
          content: "";
          display: inline-block;
          width: 3px;
          height: 11px;
          border-radius: 10px;
          background: rgba(24, 144, 255, 1);
          margin-right: 6px;
        }
      }
    }
    .data-list {
      padding: 0px;
      margin: 0px;
      list-style: none;
      .data-item {
        margin-bottom: 8px;
        display: flex;
        align-items: center;
        .header-text {
          display: inline-block;
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
          width: 230px;
        }
        .select-item {
          width: 240px;
          margin-right: 40px;
          &.select-value {
            margin-right: 12px;
          }
        }
        .del-icon {
          cursor: pointer;
          font-size: 20px;
          color: rgba(0, 0, 0, 0.65);
        }
      }
    }
    .nodata-tips {
      width: 300px;
      font-size: 14px;
      color: #999;
      text-align: center;
    }
  }
  .center-line {
    border-bottom: 1px dashed rgba(0, 0, 0, 0.2);
    margin: 12px 0px 16px 0;
  }
  .btn-wrap {
    margin-top: 20px;
    text-align: center;
    .btn-item {
      width: 74px;
      height: 32px;
    }
  }
}
</style>
